import { G_bounds } from "../../../utils/globals/globals";
import setWindowData from "../../../utils/set-window-data";
import WINDOW from "../../../utils/window";
import setBounds from "../../store/utils/set-bounds";

let timeout;

const callbackResize = () => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    const oldHeight = WINDOW.get("document-height");

    setWindowData();

    const newHeight = WINDOW.get("document-height");

    if (newHeight !== oldHeight) {
      for (const [element, main] of G_bounds) {
        delete element["tor-bounds"];

        main.bounds = setBounds(element, null, null, null, true);
      }
    }
  }, 150);
};

export default callbackResize;